import { useState } from 'react';
import type * as React from 'react';
import { useGarden } from '../../garden/GardenContext';
import type { ActionLogEntry as ActionLogEntryType } from '../../garden/gardenReducer';
import { todayISO } from '../../utils/date';
import ActionLogEntry from './ActionLogEntry';
import './ActionLog.css';

interface ActionLogProps {
  elementId: string;
  entries: ActionLogEntryType[];
}

function ActionLog({ elementId, entries }: ActionLogProps) {
  const { addActionEntry } = useGarden();
  const [date, setDate] = useState(todayISO());
  const [note, setNote] = useState('');

  function handleAdd(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!note.trim()) return;
    addActionEntry(elementId, date, note.trim());
    setDate(todayISO());
    setNote('');
  }

  const sortedEntries = [...entries].sort((a, b) => (a.date < b.date ? 1 : -1));

  return (
    <div className="action-log">
      <h3 className="action-log__title">Action log</h3>
      {sortedEntries.length === 0 ? (
        <p className="action-log__empty">No actions recorded yet.</p>
      ) : (
        <ul className="action-log__list">
          {sortedEntries.map((entry) => (
            <ActionLogEntry key={entry.id} elementId={elementId} entry={entry} />
          ))}
        </ul>
      )}
      <form className="action-log__form" onSubmit={handleAdd}>
        <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          className="action-log__date-input"
        />
        <input
          type="text"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="e.g. Pruned dead branches"
          className="action-log__note-input"
        />
        <button type="submit">Add</button>
      </form>
    </div>
  );
}

export default ActionLog;
